<template>
  <div class="w-100 w-md-75 mt-5 mb-10">
    <v-card outlined elevation="0">
      <v-form ref="form" @submit.prevent="create" class="pa-4 px-4">
        <v-row>
          <v-col class="pr-md-24">
            <div class="text-left mb-10">
              <h4 class="back--text gotham-book">General Information</h4>
            </div>
            <v-row class="mb-2">
              <v-col cols="6" class="py-0">
                <v-text-field
                  :rules="nameRules"
                  label="Name"
                  outlined
                  v-model="product.name"
                  required
                ></v-text-field>
              </v-col>
              <v-col cols="6" class="py-0">
                <v-autocomplete
                  v-model="product.productBrandId"
                  :items="brands"
                  :rules="brandRules"
                  outlined
                  label="Select Brand"
                  item-text="name"
                  item-value="id"
                ></v-autocomplete>
              </v-col>
              <v-col cols="6" class="py-0">
                <v-autocomplete
                  v-model="product.supplierId"
                  :items="suppliers"
                  :rules="supplierRules"
                  outlined
                  label="Select Supplier"
                  item-text="name"
                  item-value="id"
                ></v-autocomplete>
              </v-col>
              <v-col cols="6" class="py-0">
                <v-text-field
                  :rules="manufactureRules"
                  label="Manufacturer"
                  outlined
                  v-model="product.manufacturerId"
                  required
                ></v-text-field>
              </v-col>
              <v-col cols="12" class="py-0">
                <v-autocomplete
                  v-model="product.productSubcategories"
                  :items="subcategories"
                  outlined
                  chips
                  multiple
                  label="Select Subcategories"
                  item-text="name"
                  item-value="id"
                ></v-autocomplete>
              </v-col>
            </v-row>
            <v-divider class="mb-8"></v-divider>
            <div class="mb-10 text-left">
              <h4 class="black--text gotham-book">Specifications and Price</h4>
            </div>
            <v-row>
              <v-col cols="6" class="py-0">
                <v-text-field
                  label="Price"
                  type="number"
                  :rules="amountRules"
                  required
                  outlined
                  v-model="product.amount"
                ></v-text-field>
              </v-col>
              <v-col cols="6" class="py-0">
                <v-text-field
                  label="Size"
                  :rules="sizeRules"
                  outlined
                  v-model="product.size"
                  required
                ></v-text-field>
              </v-col>
              <v-col cols="6" class="py-0">
                <v-text-field
                  type="number"
                  label="Quantity"
                  :rules="quantityRules"
                  outlined
                  v-model="product.quantity"
                  required
                ></v-text-field>
              </v-col>
              <v-col cols="6" class="py-0">
                <v-text-field
                  label="Color"
                  :rules="colorRules"
                  outlined
                  v-model="product.colour"
                  required
                ></v-text-field>
              </v-col>
              <v-col cols="6" class="py-0">
                <v-text-field
                  label="Color"
                  :rules="weightRules"
                  outlined
                  v-model="product.weight"
                  required
                ></v-text-field>
              </v-col>
            </v-row>
            <v-divider class="mb-8"></v-divider>
            <div class="mb-10 text-left">
              <h4 class="black--text gotham-book">Availability</h4>
            </div>
            <v-row>
              <v-col>
                <v-switch
                  v-model="product.status"
                  inset
                  value="active"
                  label="Active/Inactive"
                  hide-details
                  class="mt-0"
                ></v-switch>
              </v-col>
              <v-col>
                <v-switch
                  v-model="product.surgeriesOnly"
                  inset
                  label="Surgeries only"
                  hide-details
                  class="mt-0"
                ></v-switch>
              </v-col>
            </v-row>
            <v-row class="mb-1">
              <v-col>
                <v-switch
                  v-model="product.prescriptionOnly"
                  inset
                  label="Prescription only"
                  hide-details
                  class="mt-0"
                ></v-switch>
              </v-col>
              <v-col>
                <v-switch
                  inset
                  v-model="product.isBestSeller"
                  label="Is best seller"
                  hide-details
                  class="mt-0"
                ></v-switch>
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <v-textarea
                  name="input-7-1"
                  label="Describe your product here..."
                  outlined
                  :rules="descriptionRules"
                  rows="3"
                  v-model="product.description"
                ></v-textarea>
              </v-col>
            </v-row>
            <v-divider class="mb-8"></v-divider>
            <div class="mb-6 text-left">
              <h4 class="black--text gotham-book">Shipment Profile</h4>
            </div>
            <v-row>
              <v-col>
                <v-autocomplete
                  v-model="product.shipmentProfileId"
                  :items="shipmentProfiles"
                  outlined
                  label="Select Shipment Profile"
                  item-text="name"
                  item-value="id"
                ></v-autocomplete>
              </v-col>
            </v-row>
            <v-divider class="mb-8"></v-divider>
            <div class="d-flex justify-space-between">
              <div class="mb-10 text-left">
                <h4 class="black--text gotham-book">Images</h4>
              </div>
              <div>
                <div
                  class="pointer"
                  @click="
                    showAddImage = true;
                    $forceUpdate();
                  "
                >
                  <u>Add image</u>
                </div>
              </div>
            </div>
            <v-row class="mb-8">
              <v-col
                cols="6"
                md="6"
                v-for="(image, index) in product.images"
                :key="index"
              >
                <image-picker
                  v-model="product.images[index]"
                  :add="false"
                  :uploaded="product.images[index] !== null"
                  @delete-item="deleteImage(index)"
                  @reset="product.images[index] = null"
                >
                  <div
                    slot="activator"
                    class="cursor-pointer w-100 h-100 d-flex align-center"
                  >
                    <img
                      :src="image"
                      alt="avatar"
                      width="100%"
                      height="220px"
                    />
                  </div>
                </image-picker>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
        <div class="d-flex justify-start">
          <v-btn type="submit" color="accent" class="font-bold"
            >Create Product</v-btn
          >
        </div>
      </v-form>
    </v-card>
    <v-dialog v-model="showAddImage" width="800">
      <v-card>
        <v-card-title>
          Add Image
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12" md="6">
                <image-picker :add="true" @input="addImage"> </image-picker>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import { mapState } from "vuex";
import ImagePicker from "@/components/ImagePicker.vue";
export default {
  data: () => ({
    product: {
      name: null,
      description: null,
      productBrandId: null,
      supplierId: null,
      quantity: null,
      size: null,
      colour: null,
      amount: null,
      manufacturerId: null,
      productStatusId: 1,
      productTypeId: 1,
      productSubcategories: [],
      isBestSeller: null,
      images: []
    },
    showAddImage: false,
    saving: false,
    saved: false,
    nameRules: [
      v => !!v || "Name is required",
      v => (v && v.length >= 5) || "Name must be at least 5 characters",
      v =>
        (v && v.length <= 250) || "Name must be less than than 250 characters"
    ],
    brandRules: [v => !!v || "Brand is required"],
    quantityRules: [
      v => !!v || "Quantity is required",
      v => (v && v.length >= 1) || "Quantity must be at least 1 characters",
      v =>
        (v && v.length <= 50) || "Quantity must be less than than 50 characters"
    ],
    sizeRules: [
      v => !!v || "Size is required",
      v => (v && v.length >= 1) || "Size must be at least 1",
      v => (v && v.length <= 50) || "Size must be less than than 50"
    ],
    amountRules: [
      v => !!v || "Amount is required",
      v =>
        /^(?:\d*\.\d{1,2}|\d+)$/.test(v) ||
        "Amount must be decimal number with two decimal number maximum",
      v => (v && v >= 1) || "Amount must be at least 1",
      v => (v && v <= 99999.99) || "Amount must be less then 99999.99"
    ],
    colorRules: [
      v => !!v || "Color is required",
      v => (v && v.length >= 1) || "Color must be at least 1 characters",
      v => (v && v.length <= 50) || "Color must be less than than 50 characters"
    ],
    weightRules: [
      v => !!v || "Weight is required",
      v =>
        /^(?:\d*\.\d{1,2}|\d+)$/.test(v) ||
        "Weight must be decimal number with two decimal number maximum",
      v => (v && v >= 1) || "Weight must be at least 1",
      v => (v && v <= 99999.99) || "Weight must be less then 99999.99"
    ],
    supplierRules: [v => !!v || "Supplier is required"],
    descriptionRules: [
      v => !!v || "Description is required",
      v =>
        (v && v.length >= 25) || "Description must be at least 25 characters",
      v =>
        (v && v.length <= 65535) ||
        "Description must be less than than 65,535 characters"
    ],
    manufactureRules: [
      v => !!v || "manufacture is required",
      v => (v && v.length >= 5) || "manufacture must be at least 5 characters",
      v =>
        (v && v.length <= 25) ||
        "manufacture must be less than than 25 characters"
    ]
  }),
  components: {
    ImagePicker
  },
  mounted() {
    this.$store.dispatch("brands/LOAD_BRANDS", {
      from: 0,
      to: 0
    });
    this.$store.dispatch("suppliers/LOAD_SUPPLIERS", {
      from: 0,
      to: 0
    });
    this.$store.dispatch("subcategories/LOAD_SUBCATEGORIES", {
      from: 0,
      to: 0
    });
    this.$store.dispatch("shipmentprofiles/LOAD_SHIPMENT_PROFILES", {
      from: 0,
      to: 0
    });
  },
  computed: {
    ...mapState({
      brands: state => state.brands.brands,
      suppliers: state => state.suppliers.suppliers,
      subcategories: state => state.subcategories.subcategories,
      shipmentProfiles: state => state.shipmentprofiles.shipmentProfiles
    })
  },
  methods: {
    deleteImage(index) {
      this.product.images = this.product.images.splice(index + 1, 1);
      this.$forceUpdate();
    },
    addImage(image) {
      this.product.images.push(image);
      this.showAddImage = false;
    },
    async create() {
      if (this.$refs.form.validate()) {
        this.$swal({
          title: "Adding product...",
          html: "this will only take a moment...",
          icon: "info",
          didOpen: () => {
            this.$swal.showLoading();
          }
        });
        await this.$store.dispatch("products/CREATE_PRODUCT", this.product);
      }
    }
  }
};
</script>

<style lang="scss">
.cursor-pointer {
  cursor: pointer;
}
</style>
